// @view/panels/workspace/document-creation/DocumentCreationReview.panel.tsx
import React from "react";
import * as styles from "@styles/DocumentCreation.css";
import EmptyView from "@view/EmptyView";

export type DocumentCreationReviewOutlinePhase = "empty" | "list";
export type DocumentCreationReviewOutlineExtraPhase = "hidden" | "visible";

type DocumentCreationReviewPanelProps = {
  titleText: string;
  styleText: string;
  outlinePreviewLines: string[];
  outlineExtraCount: number;
  outlinePhase: DocumentCreationReviewOutlinePhase;
  outlineExtraPhase: DocumentCreationReviewOutlineExtraPhase;
};

const DocumentCreationReviewPanel: React.FC<DocumentCreationReviewPanelProps> = ({
  titleText,
  styleText,
  outlinePreviewLines,
  outlineExtraCount,
  outlinePhase,
  outlineExtraPhase,
}) => {
  const outlineExtraView = {
    hidden: <EmptyView />,
    visible: (
      <li className={styles.outlineHint}>+{outlineExtraCount} more sections</li>
    ),
  } as const satisfies Record<
    DocumentCreationReviewOutlineExtraPhase,
    React.ReactElement
  >;

  const outlineListView = (
    <ul className={styles.outlineList}>
      {outlinePreviewLines.map((line) => (
        <li key={line} className={styles.outlineItem}>
          {line}
        </li>
      ))}
      {outlineExtraView[outlineExtraPhase]}
    </ul>
  );

  const outlineView = {
    empty: <p className={styles.reviewValue}>No outline added yet.</p>,
    list: outlineListView,
  } as const satisfies Record<
    DocumentCreationReviewOutlinePhase,
    React.ReactElement
  >;

  return (
    <div className={styles.reviewStack}>
      <div className={styles.reviewBlock}>
        <p className={styles.reviewLabel}>Document</p>
        <p className={styles.reviewValue}>{titleText}</p>
      </div>
      <div className={styles.reviewBlock}>
        <p className={styles.reviewLabel}>Intentions</p>
        <p className={styles.reviewValue}>{styleText}</p>
      </div>
      <div className={styles.reviewBlock}>
        <p className={styles.reviewLabel}>Outline</p>
        {outlineView[outlinePhase]}
      </div>
    </div>
  );
};

export default DocumentCreationReviewPanel;
